export { DefaultEffects } from '@fluentui/theme';
